
import { Box, Icon, SimpleGrid, Text, useColorModeValue } from "@chakra-ui/react";

import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import React, { useEffect, useState } from "react";
import { SiVirustotal } from "react-icons/si";
import { useDispatch } from "react-redux";
import PieCard from "views/admin/default/components/PieCard";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import { fetchAsyncGetExpenseBarChart } from "redux/userSlice";
import { fetchAsyncGetExpensePiChart } from "redux/userSlice";
import { TbReceiptTax } from "react-icons/tb";
import { useToasts } from "react-toast-notifications";
import { generateYearOptions } from "./components/filterOption";
import { getSeletedIcon } from "components/allForm/OrgnizationProfile/expenseModule/moduleIcon";

const {defaultSelected} = generateYearOptions();

export default function UserReports() {
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const [totalExpenseAmount, setTotalExpenseAmount] = useState(null);
  const dispatch = useDispatch();

  const [expenseData, setExpenseData] = useState([]);

  const [piChartData,setPiChartData] = useState([])
  const [optionBarChart, setOptionsBarChart] = useState([]);
  const [valuesBarChart, setValuesBarChart] = useState([]);

  const [selectExpYear, setSelectExpYear] = useState(defaultSelected);
  const [selectExpType, setSelectExpType] = useState("");

  const [piOptionType, setPiOptionType] = useState("yearly");
  const [piOptionYear, setPiOptionYear] = useState(defaultSelected);
  const [piOptionMonth, setPiOptionMonth] = useState("1");

  const { addToast } = useToasts();


  useEffect(() => {
    dispatch(
      fetchAsyncGetExpenseBarChart({
        expense: selectExpType,
        financialYear:selectExpYear
      })
    ).then((res) => {
      if (res.payload) {
        if (res.payload?.length > 0) {
          let options = res.payload.map((data) => Object.keys(data)[0]);
          let values = res.payload.map((data) => Object.values(data)[0]);
          setOptionsBarChart(options);
          setValuesBarChart(values);
        }
      } else {
        addToast(res.error?.message, { appearance: "error" });
      }
    });
  }, [selectExpYear, selectExpType]);

  useEffect(() => {
    if (piOptionType && piOptionYear) {
      
      dispatch(fetchAsyncGetExpensePiChart({ piOptionYear ,piOptionType,piOptionMonth})).then(
        (response) => {
          if (response.payload) {
            setPiChartData(response.payload)
          }
        }
      );
    }
  }, [piOptionType, piOptionYear, piOptionMonth]);

  useEffect(() => {
   
    if(piChartData && piChartData?.length > 0){
      const sumOfCounts = piChartData.reduce((sum, item) => {
        return sum + Number(item.total.count || 0); 
      }, 0);
  
      const data = piChartData.map((item)=>{
        return {
          name:item?.name,
          amount: Number(item.total.count || 0),
          prc: (Number(item.total.count) / Number(sumOfCounts)) * 100,
          color:item?.color
        }
      })
      setExpenseData(data)
      setTotalExpenseAmount(sumOfCounts);
    }
  }, [piChartData]);
  const textColor = useColorModeValue("secondaryGray.900", "white");

  return (
    <Box className=" main-dashboard" mx={5}>
    <Box display="flex" className="">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
          ml={1}
        >
          Main Dashboard
        </Text>
       
        </Box>
    <Box >
       
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
        gap="20px"
        mb="20px"
        mt="20px"
        className="grid-amount"
      >
         <MiniStatistics
          startContent={
            <IconBox
              w="46px"
              h="46px"
              bg={boxBg}
              icon={
                <Icon w="22px" h="22px" as={SiVirustotal} color={brandColor} />
              }
            />
          }
          name="Total Expense Amount"
          value={formatAmountInINR(totalExpenseAmount || 0)}
        />
       {piChartData && piChartData?.map((item)=>{
        return (

          <MiniStatistics
            startContent={
              <IconBox
                w="46px"
                h="46px"
                bg={boxBg}
                icon={item?.icnImg && getSeletedIcon(item.icnImg) ? 
                getSeletedIcon(item.icnImg) : <Icon w="22px" h="22px" as={TbReceiptTax} color={brandColor} />}
              />
            }
            name={`${item?.name} Total Expense`}
            value={formatAmountInINR(item?.total?.count || 0)}
          />
        )

        }
      )}
        
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap="20px">
        {optionBarChart.length > 0 && valuesBarChart.length > 0 && (
          <WeeklyRevenue
            optionBarChart={optionBarChart}
            valuesBarChart={valuesBarChart}
            changeYear={(value) => {
              setSelectExpYear(value);
            }}
            changeExpanse={(value) => {
              setSelectExpType(value);
            }}
            selectExpYear={selectExpYear}
            selectExpType={selectExpType}
          />
        )}
        {expenseData &&           
        <PieCard
            data={expenseData}
            totalAmount={totalExpenseAmount}
            changePiType={(value) => {
              setPiOptionType(value);
            }}
            changePiYear={(value) => {
              setPiOptionYear(value); 
            }}
            changePiMonth={(value) => {
              setPiOptionMonth(value);
            }}
          />
        }
      </SimpleGrid>
    </Box>
    </Box>
  );
}
